import { render } from "./FgBttm.vue?vue&type=template&id=f146cf76&scoped=true"
import script from "./FgBttm.vue?vue&type=script&lang=js"
export * from "./FgBttm.vue?vue&type=script&lang=js"

import "./FgBttm.vue?vue&type=style&index=0&id=f146cf76&scoped=true&lang=css"

import exportComponent from "/Users/info/Sites/htdocs/KVBerlin/Site_Typo10/typo3conf/ext/honorardiagramm/Resources/Public/Javascript/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f146cf76"]])

export default __exports__